/**
 * PATH: packages/ui/src/table/SortPriorityBadge.tsx
 * FILE_ID: UI-TABLE-SORTBADGE-001
 * PURPOSE: Show the rank of a secondary sort key as a small numbered pill.
 * WHY: aria-sort="other" tells a screen reader a secondary sort exists but
 *      tells a sighted operator nothing, so a two-key sort reads as a
 *      single-key sort that has malfunctioned. Rank 1 stays unbadged: a
 *      single sort needs no ordinal, which is why single-sort tables never
 *      see this at all.
 * RELATED: SortableTableHeader.tsx, sortRules.ts
 */

export function SortPriorityBadge({ rank }: { rank: number }) {
  if (rank < 2) return null
  return (
    <span
      data-sort-priority={rank}
      title={`Sort priority ${rank}`}
      className="ml-0.5 inline-flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-primary px-1 text-[9px] font-semibold leading-none text-primary-foreground"
    >
      {rank}
    </span>
  )
}
